<template>
  <el-col :span="8" class="statistic-graph">
    <el-card class="data" v-loading="loadging_budget_allocated">
      <div class="card-header" slot="header">
        <div class="card-header__title">
          <img class="report-img" src="@/assets/images/budget-alocated-icon.svg" alt="" width="32"/>
          <span>BUDGET ALLOCATED</span>
        </div>
        <div class="card-header__total">
          <div>Total: {{ total }}</div>
        </div>
      </div>
      <GChart
        type="ColumnChart"
        :data="budget_allocated_chart"
        :options="BarChartSett"
        v-if="budget_allocated_chart.length > 1"
      />
      <div v-else class="no-data"><span>No Data</span></div>
      <div class="card-footer">
        <div class="border"></div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('adminDashboard', ['BarChartSett', 'budget_allocated', 'loadging_budget_allocated']),
    ...mapGetters('adminDashboard', ['budget_allocated_chart']),

    total() {
      let total = 0
      this.budget_allocated.forEach(item => {
        total+= item.standard + item.bonus
      })
      return this.commaNum(total, 2)
    }
  },

  data() {
    return {}
  },

  methods: {
    ...mapActions('adminDashboard', ['readBudgetAllocated']),

  }
}
</script>
